import React from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  stepInstructions: {
    backgroundColor: '#F4F6F9',
    padding: 15,
    marginTop: 15
  }
});

const StepInstructions = ({classes}) => {
  return (
    <div className={classes.stepInstructions}>
    <List dense={false}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar className={classes.stepInstructionAvatar}>1</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Lue ensin vanhan laitteen QR-koodi"
                  secondary={null}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar className={classes.stepInstructionAvatar}>2</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Tarkista vanhan laitteen tiedot"
                  secondary={null}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar className={classes.stepInstructionAvatar}>3</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Lue uuden laitteen QR-koodi"
                  secondary={null}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar className={classes.stepInstructionAvatar}>4</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Tarkista yhteenveto ja hyväksy muutokset"
                  secondary={null}
                />
              </ListItem>
            </List>
      </div>
  )
}

export default withStyles(styles)(StepInstructions);




// WEBPACK FOOTER //
// ./src/components/Steps/StepInstructions.js